module.exports = __webpack_public_path__ + "static/media/Sample.c62e3fc0.less";